import { AssessmentStage } from './shared'

export const ASSESSMENT_STAGE_REPORT_COLUMNS = [
  'patientName',
  'pregnancyName',
  'eddOrDeliveryDate',
  'hasDelivered',
  'isTransfer',
  'insurer',
  'coverageIsMedicaid',
  'serviceDateRange',
  'planType',
  'insurancePaymentsToDate',
  'insurancePaymentsToDateFromPayments',
  'outstandingAmountTowardsPrm',
  'prm',
  'authOnFile',
  'authOnFileStatuses',
] as const

export type AssessmentStageReportColumn = (typeof ASSESSMENT_STAGE_REPORT_COLUMNS)[number]

// Columns (and order) a new pregnancy report starts with — a curated subset of all available columns.
export const DEFAULT_ASSESSMENT_STAGE_REPORT_COLUMNS: AssessmentStageReportColumn[] = [
  'patientName',
  'eddOrDeliveryDate',
  'insurer',
  'serviceDateRange',
]

export const ASSESSMENT_STAGE_REPORT_COLUMN_LABELS: Record<AssessmentStageReportColumn, string> = {
  patientName: 'Patient Name',
  pregnancyName: 'Pregnancy Name',
  eddOrDeliveryDate: 'EDD / Delivery Date',
  hasDelivered: 'Has Patient Delivered',
  isTransfer: 'Is Transfer',
  insurer: 'Insurer',
  coverageIsMedicaid: 'Coverage Is Medicaid',
  serviceDateRange: 'Service Date Range',
  planType: 'Plan Type',
  insurancePaymentsToDate: 'Insurance payments to date (from claims)',
  insurancePaymentsToDateFromPayments: 'Insurance payments to date (from payments)',
  outstandingAmountTowardsPrm: 'Outstanding Amount Towards PRM',
  prm: 'PRM',
  authOnFile: 'Auth on File',
  authOnFileStatuses: 'Auth on File Statuses',
}

export interface AssessmentStageReport {
  practiceId: string
  stages: AssessmentStage[]
  columns: AssessmentStageReportColumn[]
  // Whether archived pregnancies were included in the report (default false).
  includeArchived?: boolean
  status: 'generating' | 'generated' | 'error_generating'
  storagePath?: string
  errorMessage?: string
  createdOn: number
  createdBy: string
}
